import { EventCatalogFromKeys, EventType } from "../../../types";

export const NeedDetailsEventKeys = {
  NEED_DETAILS_CLIENT_EXPORT: "need-details-client-export",
  NEED_DETAILS_DUPLICATE_ATTEMPT: "need-details-duplicate-attempt",
  NEED_DETAILS_DUPLICATE_FAILURE: "need-details-duplicate-failure",
  NEED_DETAILS_DUPLICATE_SUCCESS: "need-details-duplicate-success",
  NEED_DETAILS_EDIT_CLICK: "need-details-edit-click",
  NEED_DETAILS_SEND_REMINDER_ATTEMPT: "need-details-send-reminder-attempt",
  NEED_DETAILS_SEND_REMINDER_FAILURE: "need-details-send-reminder-failure",
  NEED_DETAILS_SEND_REMINDER_SUCCESS: "need-details-send-reminder-success",
} as const;

export const NeedDetailsEventCatalog: EventCatalogFromKeys<
  typeof NeedDetailsEventKeys
> = {
  [NeedDetailsEventKeys.NEED_DETAILS_DUPLICATE_ATTEMPT]: {
    description: "User attempted to duplicate a need in NeedDetailsClient",
    eventType: EventType.INTERACTION,
    id: NeedDetailsEventKeys.NEED_DETAILS_DUPLICATE_ATTEMPT,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_DUPLICATE_FAILURE]: {
    description: "User failed to duplicate a need in NeedDetailsClient",
    eventType: EventType.ERROR,
    id: NeedDetailsEventKeys.NEED_DETAILS_DUPLICATE_FAILURE,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_DUPLICATE_SUCCESS]: {
    description: "User successfully duplicated a need in NeedDetailsClient",
    eventType: EventType.INTERACTION,
    id: NeedDetailsEventKeys.NEED_DETAILS_DUPLICATE_SUCCESS,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_EDIT_CLICK]: {
    description: "User clicked edit in NeedDetailsClient",
    eventType: EventType.BUTTON_CLICK,
    id: NeedDetailsEventKeys.NEED_DETAILS_EDIT_CLICK,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_SEND_REMINDER_ATTEMPT]: {
    description: "User attempted to send a reminder in NeedDetailsClient",
    eventType: EventType.INTERACTION,
    id: NeedDetailsEventKeys.NEED_DETAILS_SEND_REMINDER_ATTEMPT,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_SEND_REMINDER_FAILURE]: {
    description: "User failed to send a reminder in NeedDetailsClient",
    eventType: EventType.ERROR,
    id: NeedDetailsEventKeys.NEED_DETAILS_SEND_REMINDER_FAILURE,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_SEND_REMINDER_SUCCESS]: {
    description: "User successfully sent a reminder in NeedDetailsClient",
    eventType: EventType.INTERACTION,
    id: NeedDetailsEventKeys.NEED_DETAILS_SEND_REMINDER_SUCCESS,
  },
  [NeedDetailsEventKeys.NEED_DETAILS_CLIENT_EXPORT]: {
    description: "User exported data in NeedDetailsClient",
    eventType: EventType.INTERACTION,
    id: NeedDetailsEventKeys.NEED_DETAILS_CLIENT_EXPORT,
  },
};
